import { useQuery } from "@tanstack/react-query";
import { queryKeys } from "../../../shared/lib/query-keys.ts";
import { getDiscoveryStatus } from "../api/discovery-api.ts";
import type { DiscoveryStatusData } from "../types/index.ts";

export function useDiscoveryStatusQuery(enabled: boolean) {
  return useQuery<DiscoveryStatusData | null>({
    queryKey: queryKeys.discovery.status(),
    queryFn: () => getDiscoveryStatus(),
    enabled,
    refetchInterval: (query) => {
      const data = query.state.data;
      return data?.currentJob.status === "running" ? 2_000 : 15_000;
    },
  });
}
